import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function investimentosService() {
	const api = useApi()

	async function getInvestimentosPf(query = '') {
		return api.query(
			`${window.origin}${URLS.investimentos_clientes_pf_api}${query}`
		)
	}
	async function getMetaDadosInvestimentos(query = '') {
		return api.query(
			`${window.origin}${URLS.investimentos_clientes_pf_api}${query}`
		)
	}
	return {
		getInvestimentosPf,
		getMetaDadosInvestimentos,
	}
}
